<section id="depoimento">

  <div class="container">

    <img class="quotes-decoration" src="assets/imagens/quotes.png" alt="alternative">

    <div class="section-header">
      <h2>{{ data.TITULO }}</h2>
    </div>

    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-12">
        <div class="depoimento">
          <b>{{ data.NOME }}</b>
          <p class="m-0">{{ data.CARGO }}</p>
          <p class="m-0">{{ data.OPERACAO }}</p>
          <b>{{ data.EMPRESA }}</b>

          <p class="card-text mt-4">{{ data.DESCRICAO }}</p>
        </div>
      </div>
    </div>

  </div>

</section>